import { Box, Button, Typography } from "@mui/material";
import React from "react";
import { dataSourceList } from "../utils/data";

const AboutUs = () => {
  return (
    <Box className="bg-white flex-column  w-full rounded-[20px] border border-primary-blue-100">
      <Box className="flex-between-center gap-5 p-5 border-b border-b-primary-blue-100 ">
        <Typography className="!text-xl !font-medium">
          About Trial Partners
        </Typography>
      </Box>

      <Box className="py-6 px-5">
        <h1 className="font-medium text-lg">About Us</h1>
        <br />

        <p className="font-base text-primary-black-800">
          Welcome to TrialPartners, your trusted ally in optimizing digital
          advertising campaigns.
        </p>
        <br />
        <p className="font-base text-primary-black-800">
          At TrialPartners, we are committed to empowering businesses with
          actionable insights and precise data to drive impactful marketing
          strategies. Our platform simplifies complex campaign metrics, enabling
          marketers to measure performance, identify trends, and maximize ROI
          across multiple advertising channels.
        </p>
        <br />

        <h1 className="font-medium text-lg">Our Mission</h1>
        <br />
        <p className="font-base text-primary-black-800">
          Our mission is to help businesses unlock the full potential of their
          digital advertising efforts. We strive to provide a user-friendly,
          data-driven interface that streamlines decision-making and ensures
          every marketing dollar is spent wisely.
        </p>
        <br />

        <h1 className="font-medium text-lg">What We Do</h1>
        <br />

        <p className="font-base text-primary-black-800">We specialize in:</p>
        <ul className="ml-5">
          <li className="font-base text-primary-black-800">
            Comprehensive Analytics: Get a complete overview of your campaigns
            with metrics like impressions, clicks, conversions, and
            cost-per-click.{" "}
          </li>
          <li className="font-base text-primary-black-800">
            Platform Insights: Compare performance across major platforms like
            Google, Facebook, Instagram, and TikTok to find what works best for
            your business.{" "}
          </li>
          <li className="font-base text-primary-black-800">
            Detailed Cost Analysis: Understand the cost per conversion, return
            on ad spend, and campaign efficiency with our intuitive dashboards.
          </li>
          <li className="font-base text-primary-black-800">
            User Engagement Trends: Track how your audience interacts with ads
            across devices, from mobile phones to tablets and desktops.
          </li>
        </ul>
        <br />

        <h1 className="font-medium text-lg">Why Choose TrialPartners?</h1>
        <br />

        <p className="font-base text-primary-black-800">
          Our platform is designed for marketers who value clarity, precision,
          and results. Whether you're managing campaigns for a small business or
          a global brand, TrialPartners provides the tools you need to stay
          ahead of the competition.
        </p>
        <br />
        <p className="font-base text-primary-black-800">
          Join us and take the guesswork out of your digital advertising
          efforts. Let’s create campaigns that convert and grow your business
          like never before.
        </p>
        <br />
      </Box>
    </Box>
  );
};

export default AboutUs;
